import styled from 'styled-components';
import Heading from '../Heading';
const H5 = styled(Heading).withConfig({
  displayName: "H5",
  componentId: "ddek7-0"
})([".hs-private.hs-private.hs-private &{}"]);
H5.propTypes = Heading.propTypes;

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
H5.defaultProps = Object.assign({}, Heading.defaultProps, {
  tagName: 'h5'
});
H5.displayName = 'H5';
export default H5;